// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import { withRouter } from 'react-router';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import AddTeam from '../addTeam';
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';
import AddMember from '../addTournamentTeamMember';
import Dialog from 'material-ui/Dialog';
import EditTournamentTeam from '../editTournamentTeam';

class AddTournamentTeam extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      id: props.match.params.id,
      teams: [],
      groups: [],
      game_types: [],
      team_list :[],
      age_groups:[],
      tournament_team_details: {
        competition_id:props.match.params.id,
        name: '',
        group: '',
        game_type:'',
        logo:'',
        jersey:'',
        age_group:'',
        amount_paid:0,
      },
      team_name:'',
      team_id:'',
      addMemberView:false,
      data_uploaded: false,
      data_error: false,
      addNewTeamView:false,
      editTeamView:false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleFileLogo = this.handleFileLogo.bind(this);
    this.handleFileJersey = this.handleFileJersey.bind(this);

  }


  componentDidMount() {
    this.getaddTeamInputs();
    this.getTeamDetailInput();
    console.log(this.state);
  }
  getTeamDetailInput() {
     const url = `${getLocationOrigin()}/eagleeye/get_inputs_for_add_tournament_team/`;
     const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
         this.setState({ teams: data.teams, groups: data.groups,age_groups:data.age_groups});
        })
       .catch(error => error);
  } 

  getaddTeamInputs() {
     const url = `${getLocationOrigin()}/eagleeye/get_inputs_for_add_team/`;
     const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
         this.setState({game_types: data.game_types});
        })
       .catch(error => error);
  }
  postaddTournamentTeam(data, props) {
    console.log('postaddTournamentTeam')
      if(data.group == ''){data.group=this.state.groups[0]}
      if(data.game_type == ''){data.game_type=this.state.game_types[0].pk}
      if(data.age_group == ''){data.age_group=this.state.age_groups[0].id}
      console.log(data)
      const url = `${getLocationOrigin()}/eagleeye/create_tournament_team/`;
      const options = {...defaultOptions};
      var formData = new FormData();
      for(var name in data) {
        formData.append(name, data[name]);
      }
      options['method'] = 'post';
      options['body'] = formData;
      console.log('Going to fetch');
      return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON)
        .then((response) => {                      // first then()
            alert(response.message);
            this.toBack();
            
          })
        .catch(error => {
          console.log(error);
          alert(error.message);
        });
    
  }

  handleChange(event) {
    const name = event.target.name;
    console.log(event.target.name,event.target.value)
    var new_selected_one =  Object.assign({}, this.state.tournament_team_details);
    new_selected_one[name] = event.target.value
    this.setState({tournament_team_details: new_selected_one});
  }
  handleFileLogo(selectorFiles: FileList){
    var new_selected_one =  Object.assign({}, this.state.tournament_team_details);
    console.log('Fileeeee');
    console.log(selectorFiles);
    new_selected_one['logo'] = selectorFiles[0]
    this.setState({tournament_team_details: new_selected_one});
  }
  toAddPlayerView(team){
    console.log(team.team.id,team.team.name)
    this.setState({team_name:team.team.name,team_id:team.team.id,addMemberView:!this.state.addMemberView})
  }

  handleFileJersey(selectorFiles: FileList){
    var new_selected_one =  Object.assign({}, this.state.tournament_team_details);
    console.log('Fileeeee');
    console.log(selectorFiles);
    new_selected_one['jersey'] = selectorFiles[0]
    this.setState({tournament_team_details: new_selected_one});
  }
  handleSubmit(event) {
    event.preventDefault();
    this.postaddTournamentTeam(this.state.tournament_team_details, this.props);
    console.log('post');
    console.log(this.state);
  }
  toBack(){
    this.props.history.goBack();
  }
  render() {
    console.log('Teams')
    console.log(this.state)
    return(

      <div className="col-md-12 " style={styles.container}>          
           
        <div className="col-md-8 table_container1" >
          <div style={styles.main_header} className="col-md-12">
            <h3 style={{textAlign:'center'}}>Add New Team</h3>
          </div>
          <form  className="validated-form form-horizontal" onSubmit={this.handleSubmit}>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Team Name
              </div>
              <div className="col-md-6 " style={{width:'60%'}}>
                <input type="text" style={styles.input} name="name" className="required"
                  value={this.state.value} onChange={this.handleChange}/>
              </div>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Game Type
              </div>
              <div className="col-md-6" style={{width:'60%'}}>
                    <select name="game_type" className="col-md-6" style={styles.item_body} value={this.state.value}
                      onChange={this.handleChange}>
                      {
                        this.state.game_types.map((x, index) => (
                        <option key={x.pk} value={x.pk}>{x.game + " : " + x.name}</option>
                        ))
                      }
                    </select>
              </div>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Age Group 
              </div>
              <div className="col-md-6" style={{width:'60%'}}>
                    <select name="age_group"   value={this.state.value}
                      onChange={this.handleChange}>
                      {
                        this.state.age_groups.map((x, index) => (
                        <option key={x.id} value={x.id}>{ x.name}</option>
                        ))
                      }
                    </select>
              </div>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Logo
              </div>
              <div className="col-md-6" style={{width:'60%'}}>
                <input type="file" style={styles.input} name="logo" onChange={ (e) => this.handleFileLogo(e.target.files) }/>
              </div>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Jersey
              </div>
              <div className="col-md-6" style={{width:'60%'}}>
                <input type="file" style={styles.input} name="jersey" onChange={ (e) => this.handleFileJersey(e.target.files) }/>
              </div>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Group
              </div>
              <div className="col-md-6" style={{width:'60%'}}>
                    <select name="group"  style={styles.item_body} value={this.state.value}
                      onChange={this.handleChange}>
                      {
                        this.state.groups.map((x, index) => (
                        <option key={x} value={x}>{x}</option>
                        ))
                      }
                    </select>
              </div>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Amount Paid
              </div>
              <div className="col-md-6 " style={{width:'60%'}}>
                <input type="number" style={styles.input} name="amount_paid" className="required"
                  value={this.state.value} onChange={this.handleChange}/>
              </div>
            </div>
            <div style={styles.button_submit} className="col-md-12">
              <input className="button1" type="submit" value="Submit"  />
              <input className="button1" type="button" value="Cancel" style={{backgroundColor:'red',color:'#ffffff'}} onClick={() => {this.toBack()}} />
            </div>
            
          </form>
        </div>
      
      </div>
    );
  }
}

export default AddTournamentTeam;



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/addTournamentTeam/index.js